import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { apiClient } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const tok = localStorage.getItem("ptp_token");
    if (!tok) { setUser(null); setSubscription(null); setLoading(false); return; }
    try {
      const r = await apiClient.get("/auth/me");
      setUser(r.data.user);
      setSubscription(r.data.subscription);
    } catch {
      localStorage.removeItem("ptp_token");
      setUser(null); setSubscription(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const r = await apiClient.post("/auth/login", { email, password });
    localStorage.setItem("ptp_token", r.data.token);
    setUser(r.data.user); setSubscription(r.data.subscription);
    return r.data;
  };
  const registerTeacher = async (payload) => {
    const r = await apiClient.post("/auth/register-teacher", payload);
    localStorage.setItem("ptp_token", r.data.token);
    setUser(r.data.user); setSubscription(r.data.subscription);
    return r.data;
  };
  const registerStudent = async (payload) => {
    const r = await apiClient.post("/auth/register-student", payload);
    localStorage.setItem("ptp_token", r.data.token);
    setUser(r.data.user); setSubscription(r.data.subscription);
    return r.data;
  };
  const registerSoloStudent = async (payload) => {
    const r = await apiClient.post("/auth/register-student", { ...payload, invite_code: null });
    localStorage.setItem("ptp_token", r.data.token);
    setUser(r.data.user); setSubscription(r.data.subscription);
    return r.data;
  };
  const logout = () => { localStorage.removeItem("ptp_token"); setUser(null); setSubscription(null); };

  const value = useMemo(
    () => ({ user, subscription, loading, login, logout, registerTeacher, registerStudent, registerSoloStudent, refresh, setUser }),
    [user, subscription, loading, refresh],
  );

  return (
    <AuthCtx.Provider value={value}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
